export default __webpack_public_path__ + "static/media/greyLivingRoom.7dbb8f27.jpg";